var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { class: _vm.style.navigation }, [
    _c(
      "div",
      { staticClass: "asc__nav" },
      _vm._l(_vm.navigation, function(links, i) {
        return _c(
          "div",
          { key: i, staticClass: "asc__nav-list" },
          [
            _c(
              "b-button",
              {
                directives: [
                  {
                    name: "b-toggle",
                    rawName: "v-b-toggle",
                    value: "mobileNavLink" + i,
                    expression: "'mobileNavLink' + i"
                  }
                ],
                staticClass: "asc__nav-list-btn",
                attrs: { variant: "default" }
              },
              [_vm._v("\n        " + _vm._s(links.title) + "\n        ")]
            ),
            _vm._v(" "),
            links.sub
              ? _c("b-collapse", { attrs: { id: "mobileNavLink" + i } }, [
                  _c(
                    "ul",
                    _vm._l(links.sub, function(subs, x) {
                      return _c(
                        "li",
                        {
                          key: "sub" + x,
                          staticClass: "asc__nav-title-li",
                          on: {
                            click: function($event) {
                              return _vm.collapseNav()
                            }
                          }
                        },
                        [
                          _c(
                            "router-link",
                            {
                              staticClass: "asc__nav-title",
                              attrs: {
                                to: {
                                  name: subs.router,
                                  params: { url: subs.link }
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(subs.title) +
                                  "\n            "
                              )
                            ]
                          )
                        ],
                        1
                      )
                    }),
                    0
                  )
                ])
              : _vm._e()
          ],
          1
        )
      }),
      0
    ),
    _vm._v(" "),
    _c("figure", { staticClass: "asc__system-navLogo" }, [
      _c("img", { attrs: { src: _vm.logo.idea } })
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "asc__system-verno" }, [
      _c("span", [_vm._v("V")]),
      _vm._v(" " + _vm._s(_vm.system.version) + "\n  ")
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-81440b78", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-81440b78","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Navigation.vue
// module id = null
// module chunks = 